exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".saving_from_GroupItem-css_qU0 {\r\n  padding: 32px;\r\n  margin: 0 auto;\r\n  text-align: center;\r\n  font-size: 0.975em;\r\n  font-weight: 600;\r\n  color: #6F7583;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"saving": "saving_from_GroupItem-css_qU0"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??ref--3-2!./app/web/src/routes/sales/Lead/BusinessGroup/GroupItem.css
// module id = ./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/BusinessGroup/GroupItem.css
// module chunks = 0